import * as React from "react"
import {
  DatagridConfigurable,
  DateField,
  List,
  SearchInput,
  TopToolbar,
  TextField,
  useListContext,
  useRecordContext,
  NumberField,
} from "react-admin"
import { useMediaQuery, Button, Box, Typography } from "@mui/material"
import ContentFilter from '@mui/icons-material/FilterList';
import OrderFilterForm from "./OrderFilterForm"

const OrderFilterButton = () => {
  const { showFilter } = useListContext()
  return (
    <Button
      size="small"
      color="primary"
      onClick={() => showFilter("main")}
      startIcon={<ContentFilter />}
      sx={{
        height: '27.5px', // 調整按鈕高度
        padding: '4px 5px', // 調整內邊距
        fontSize: '13px', // 調整字型大小，這樣可以與 CreateButton 大小對齊
      }}
    >
      篩選
    </Button>
  )
}

const mobileFilters = [
  <SearchInput source="q" alwaysOn />
]

const ContactListActions = () => (
  <Box width="100%">
    <TopToolbar>
      <OrderFilterButton />
    </TopToolbar>
    <OrderFilterForm />
  </Box>
)

const OrderTitle = () => {
  return <span>{'訂單'}</span>;
};

const OrderList = () => {
  const isXsmall = useMediaQuery(theme => theme.breakpoints.down("sm"))
  const isSmall = useMediaQuery(theme => theme.breakpoints.down("md"))

  // const ImageWithDownload = () => {
  //   const record = useRecordContext();

  //   if (!record?.imageUrl) return null;

  //   const handleDownload = async () => {
  //     try {
  //       const response = await fetch(record.imageUrl);
  //       const blob = await response.blob();
  //       const blobUrl = URL.createObjectURL(blob);
        
  //       const link = document.createElement("a");
  //       link.href = blobUrl;
  //       link.download = record.fileName || "image.jpg";
  //       link.click();
        
  //       URL.revokeObjectURL(blobUrl);
  //     } catch (error) {
  //       console.error("下載圖片失敗:", error);
  //     }
  //   };

  //   return (
  //     <Box display="flex" alignItems="center" gap={1} mr={1}>
  //       <img
  //         src={record.imageUrl}
  //         alt={record.fileName}
  //         style={{ width: 60, height: "auto", objectFit: "cover", borderRadius: 4 }}
  //       />
  //       <IconButton onClick={handleDownload} size="small">
  //         <DownloadIcon fontSize="small" />
  //       </IconButton>
  //     </Box>
  //   );
  // };

  const TruncatedTextField = ({ source, maxLength = 30 }) => {
    const record = useRecordContext();
    const text = record?.[source] || '';
    const truncatedText = text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;

    return (
      <Typography variant="body2" title={text}>
        {truncatedText}
      </Typography>
    );
  };

  return (
    <List
      title={<OrderTitle/>}
      filters={isSmall ? mobileFilters : undefined}
      sort={{ field: "createdAt", order: "DESC" }}
      perPage={25}
      actions={<ContactListActions />}
    >
      {isXsmall ? (
        <div></div>
      ) : (
        <DatagridConfigurable
          sx={{
            "& .column-groups": {
              md: { display: "none" },
              lg: { display: "table-cell" }
            },
            "& .name-cell": {
              maxWidth: 120,
              overflow: "hidden",
            }
          }}
          omit={["id"]}
          bulkActionButtons={false}
          rowClick="edit"
        >
          <TextField
            source="id"
            label="ID"
          />
          <TextField
            source="orderNumber"
            label="訂單編號"
            sortBy="orderNumber"
            cellClassName="name-cell"
          />
          <TextField
            source="buyerName"
            label="訂購人名稱"
            sortBy="buyerName"
            cellClassName="name-cell"
          />
          <TextField
            source="buyerPhone"
            label="訂購人電話"
            sortBy="buyerPhone"
            cellClassName="name-cell"
          />
          <DateField 
            source="createdAt" 
            label="建立日期"  
            showTime
            cellClassName="name-cell"
          />
          <TextField
            source="statusName"
            label="訂單狀態"
            sortBy="status"
            cellClassName="name-cell"
          />
          <TextField
            source="paymentName"
            label="付款方式"
            sortBy="method"
            cellClassName="name-cell"
          />
          <NumberField 
            source="totalAmount" 
            label="總金額"
            textAlign="right"
            options={{
              style: 'currency',
              currency: 'TWD',
              minimumFractionDigits: 2,
            }}
            cellClassName="name-cell"
          />
          <TruncatedTextField 
            source="note" 
            maxLength={15} 
            label="備註"
            width={150}
            cellClassName="name-cell"
          />
        </DatagridConfigurable>
      )}
    </List>
  )
}

export default OrderList